import type { AreaType } from '../context/AreaContext';

/** Área escolhida manualmente no menu; bloqueia sync rota→área até concluir navegação. */
let pendingUserArea: AreaType | null = null;

export function markUserAreaSelection(area: AreaType): void {
  pendingUserArea = area;
}

export function clearUserAreaSelection(): void {
  pendingUserArea = null;
}

export function getPendingUserArea(): AreaType | null {
  return pendingUserArea;
}
